import React, { useState, useEffect } from 'react';
import Moment from 'react-moment';
import moment from 'moment';
import EmployeeBenefit from "./EmployeeBenefit";
import toastr from "toastr";
import axios from "axios";
import { CustomLoading } from 'components/CustomLoading';
import {Modal} from "react-bootstrap";
import {Card} from "../ktm-ui";
import { User, Mail, Building2, Calendar, Shield, CreditCard, Users, GraduationCap, StickyNote, FileText, Smartphone } from "lucide-react";

const ViewEmployee = ({ data }) => {
	const [employeeNotes, setEmployeeNotes] = useState('');
	const [employeeNotesUpdatedAt, setEmployeeNotesUpdatedAt] = useState(null);
	const [employeeSupportNotes, setEmployeeSupportNotes] = useState('');
	const [employeeSupportNotesUpdatedAt, setEmployeeSupportNotesUpdatedAt] = useState(null);
	const [loading, setLoading] = useState(true);
	const [showCreateUserModal, setShowCreateUserModal] = useState(false);
	const [createdUser, setCreatedUser] = useState(false);
	const [employeeData, setEmployeeData] = useState(null);


	useEffect(() => {
		setLoading(true);
		setCreatedUser(false);
		if (data.id) {
			Promise.all([fetchEmployeeDetails(), fetchEmployeeNotes(), fetchEmployeeSupportNotes()]).finally(() => {
				setLoading(false);
			});
		}
	}, [data.id]);

	const handleEmployeeNotesChange = (e) => {
		setEmployeeNotes(e.target.value);
	};

	const handleEmployeeSupportNotesChange = (e) => {
		setEmployeeSupportNotes(e.target.value);
	};

	const fetchEmployeeDetails = async () => {
		try{
			const response = await axios.get(
			`/api/supportemployee/getemployee?policyId=${data.polId}&employeeId=${data.id}`
			);
			if (response.data){
				setEmployeeData(response.data);
			}
		}catch (error) {
			toastr.error("Failed to fetch employee details", "Error");
		}
	}


	const fetchEmployeeNotes = async () => {
		try {
			const response = await axios.get(`/api/support/employeenotes?employeeId=${data.id}`);
			if (response.data && response.data.noteText != null) {
				setEmployeeNotes(response.data.noteText);
				setEmployeeNotesUpdatedAt(response.data.updatedAt);
			} else {
				setEmployeeNotes("");
			}
		} catch (error) {
			toastr.error("Failed to fetch employee notes", "Error");
		}
	};

	const fetchEmployeeSupportNotes = async () => {
		try {
			const response = await axios.get(`/api/support/employesupportenotes?employeeId=${data.id}`);
			if (response.data && response.data.noteText != null) {
				setEmployeeSupportNotes(response.data.noteText);
				setEmployeeSupportNotesUpdatedAt(response.data.updatedAt);
			} else {
				setEmployeeSupportNotes("");
			}
		} catch (error) {
			toastr.error("Failed to fetch employee notes", "Error");
		}
	}

	const saveEmployeeNotes = () => {
		var noteId = null;
		if (data.employeeNotes != null) {
			noteId = data.employeeNotes.id;
		}

		var body = {
			Id: noteId,
			EmployeeId: data.id,
			Notes: employeeNotes,
		};
		var self = this;
		axios({
			method: "post",
			url: "/api/support/saveemployeenotes",
			data: body,
		})
			.then(function (response) {
				if (!response.data.success) {
					toastr.success("Notes updated", "Success");
					fetchEmployeeNotes();
				}
			})
			.catch(function (error) {
				toastr.error("Failed save notes", "Error");
			});
	};

	const saveEmployeeSupportNotes = () => {
		var noteId = null;
		if (data.employeeSupportNotes != null) {
			noteId = data.employeeSupportNotes.id;
		}

		var body = {
			Id: noteId,
			EmployeeId: data.id,
			Notes: employeeSupportNotes,
		};
		var self = this;
		axios({
			method: "post",
			url: "/api/support/saveemployeesupportnotes",
			data: body,
		})
			.then(function (response) {
				if (!response.data.success) {
					toastr.success("Notes updated", "Success");
					fetchEmployeeSupportNotes();
				}
			})
			.catch(function (error) {
				toastr.error("Failed save notes", "Error");
			});
	};

	const renderPlanAdmins = () => {
		return employeeData.planAdmins && employeeData.planAdmins.length > 0 ? (
			employeeData.planAdmins.map((item, i) => (
				<div key={i}>
					{item.lastName} {item.firstName} <a href={`mailto:${item.email}`} target="_blank" rel="noopener noreferrer" style={{ color: "blue" }}>{item.email}</a>
					{item.readOnly && <span style={{ marginLeft: "6px", color: "#856404", backgroundColor: "#fff3cd", border: "1px solid #ffc107", borderRadius: "3px", padding: "1px 6px", fontSize: "12px", fontWeight: 500 }}>Read Only</span>}
				</div>
			))
		) : null;
	};

	const renderPlanAdminsCompanyList = () => {
		return employeeData.policyHolderNames && employeeData.policyHolderNames.length > 0 ? (
			<div>
				<p style={{ color: "#f44336", fontWeight: "bold", fontSize: "14px", marginBottom: "5px" }}>
					This user is a Plan Admin of the Companies below:
				</p>
				<ul style={{ listStyleType: "disc", paddingLeft: "20px" }}>
					{employeeData.policyHolderNames.map((item, i) => (
						<li key={i} style={{ marginBottom: "2px" }}>
							<a
								href="#"
								style={{ textDecoration: "none", color: "#007bff" }}
								onClick={(e) => {
									e.preventDefault(); // Prevent default anchor behavior
									window.open(
										"/ops/enroll.policy.record?policy_id=" + item.id,
										"_blank"
									);
								}}
							>
								{item.name}
							</a>
							{item.readOnly && <span style={{ marginLeft: "6px", color: "#856404", backgroundColor: "#fff3cd", border: "1px solid #ffc107", borderRadius: "3px", padding: "1px 6px", fontSize: "12px", fontWeight: 500 }}>Read Only</span>}
						</li>
					))}
				</ul>
			</div>
		) : null;
	};


	const renderDependents = () => {
		return employeeData.dependents && employeeData.dependents.length > 0 ? (
			<div className="view-detail-row">
				<div className="view-detail-label"><Users size={15}/> Dependents</div>
				<div className="view-detail-value">
					<div className="dashboard-table-container">
						<table className="table table-hover">
							<thead>
							<tr>
								<th>Name</th>
								<th>Type</th>
								<th>Hidden</th>
							</tr>
							</thead>
							<tbody>
							{employeeData.dependents.map((dep, i) => (
								<tr key={i}>
									<td>{dep.firstName} {dep.lastName}</td>
									<td>{dep.relation}</td>
									<td>{dep.isHidden ? "Yes" : "No"}</td>
								</tr>
							))}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		) : null;
	};

	if (loading) {
		return <CustomLoading />;
	}

	const createUser = (data) => {
		axios({
			method: "post",
			url: "/api/support/createuseraccount",
			data: data,
		})
		.then((response) => {
			if (response.status === 200) {
				toastr.success(response.data.message);
				setCreatedUser(true);
			}
			else {
				toastr.error("Failed to create user", response.status);
				setCreatedUser(false);
			}
		})
		.catch((error) => {
			toastr.error("Failed to create user", error);
		})
		.finally(() => setShowCreateUserModal(false));
	}

	return (
		<div className="mt-3 view-detail-card">
			<div className="view-detail-row">
				<div className="view-detail-label"><User size={15}/> Name</div>
				<div className="view-detail-value"><b>{data.lastName}, {data.firstName}</b></div>
			</div>
			<div className="view-detail-row">
				<div className="view-detail-label"><Mail size={15}/> Email</div>
				<div className="view-detail-value">
					<a
						href={"mailto:" + data.email}
						target="_blank"
						style={{color: "blue"}}
					>
						{data.email}
					</a>
				</div>
			</div>
			<div className="view-detail-row">
				<div className="view-detail-label"><Shield size={15}/> User Account</div>
				<div className="view-detail-value">
					{data.user || createdUser ? <b>Enabled</b> : <><b>Disabled </b>
						<a
							target="_blank"
							style={{color: "blue", cursor: "pointer"}}
							onClick={() => setShowCreateUserModal(true)}
						>
							Create User Account
						</a></>}
				</div>
			</div>
			<div className="view-detail-row">
				<div className="view-detail-label"><CreditCard size={15}/> Bank EFT</div>
				<div className="view-detail-value">
					<b>{data.bankInfo}</b>
				</div>
			</div>
			<div className="view-detail-row">
				<div className="view-detail-label"><Building2 size={15}/> Company</div>
				<div className="view-detail-value">
					<b>{data.policyName}</b>
				</div>
			</div>
			<div className="view-detail-row">
				<div className="view-detail-label"><Calendar size={15}/> DOB</div>
				<div className="view-detail-value">
					<Moment local format="YYYY/MM/DD">
						{data.dob}
					</Moment>
				</div>
			</div>
			<div className="view-detail-row">
				<div className="view-detail-label"><Users size={15}/> Plan Admin</div>
				<div className="view-detail-value">{renderPlanAdmins()}</div>
			</div>
			<div className="view-detail-row">
				<div className="view-detail-label"><GraduationCap size={15}/> Is Trained</div>
				<div className="view-detail-value">
					{data.isTrained ? <b>Yes</b> : <b>No</b>}
				</div>
			</div>
			<div className="view-detail-row">
				<div className="view-detail-label"><Building2 size={15}/> Assigned Companies</div>
				<div className="view-detail-value">{renderPlanAdminsCompanyList()}</div>
			</div>
			<div className="view-detail-row">
				<div className="view-detail-label"><StickyNote size={15}/> Employee Notes</div>
				<div className="view-detail-value">
					<div>
						<span>
              Note updated at :
              <Moment local format="YYYY/MM/DD hh:mm A">
                {employeeNotesUpdatedAt}
              </Moment>
            </span>
					</div>
					<textarea className="form-control" value={employeeNotes}
							  onChange={handleEmployeeNotesChange}></textarea>
					<button type="button" className="btn btn-primary btn-sm mt-1"
							onClick={saveEmployeeNotes}>Save
					</button>
				</div>
			</div>
			<div className="view-detail-row">
				<div className="view-detail-label"><FileText size={15}/> Authorized Account Access Notes</div>
				<div className="view-detail-value">
					<div>
						<span>
              Note updated at :
              <Moment local format="YYYY/MM/DD hh:mm A">
                {employeeSupportNotesUpdatedAt}
              </Moment>
            </span>
					</div>
					<textarea className="form-control" value={employeeSupportNotes}
							  onChange={handleEmployeeSupportNotesChange}></textarea>
					<button type="button" className="btn btn-primary btn-sm mt-1"
							onClick={saveEmployeeSupportNotes}>Save
					</button>
				</div>
			</div>
			<div className="view-detail-row">
				<div className="view-detail-label"><StickyNote size={15}/> Company Notes</div>
				<div className="view-detail-value">{employeeData.policyNotes != null ? employeeData.policyNotes.noteText : ""}</div>
			</div>
			{renderDependents()}
			<div className="view-detail-row" style={{ borderTop: "2px solid #dee2e6", marginTop: "10px", paddingTop: "10px" }}>
				<div className="view-detail-label"><Smartphone size={15}/> <b>ClaimSnap</b></div>
				<div className="view-detail-value"></div>
			</div>
			<div className="view-detail-row">
				<div className="view-detail-label">Last App Version</div>
				<div className="view-detail-value">{employeeData.claimSnap?.lastAppVersion || ""}</div>
			</div>
			<div className="view-detail-row">
				<div className="view-detail-label">Last Platform</div>
				<div className="view-detail-value">{employeeData.claimSnap?.lastPlatform || ""}</div>
			</div>
			<div className="view-detail-row">
				<div className="view-detail-label">Last Seen At</div>
				<div className="view-detail-value">
					{employeeData.claimSnap?.lastSeenAt
						? moment.utc(employeeData.claimSnap.lastSeenAt).local().format("YYYY-MM-DD hh:mm A")
						: ""}
				</div>
			</div>
			<div className="view-detail-row">
				<div className="view-detail-label">Last Device</div>
				<div className="view-detail-value">{employeeData.claimSnap?.lastDeviceModel || ""}</div>
			</div>
			<br/>
			<EmployeeBenefit
				policyId={data.polId}
				employeeId={data.id}
				companyName={employeeData.company.name}
			/>
			<Modal className="edit-planadmin-setting-modal" show={showCreateUserModal} onHide={() => setShowCreateUserModal(false)}>
				<Modal.Header closeButton>
					Create User Account
				</Modal.Header>
				<Modal.Body>
					<Card>
						Are you sure  you want to create a user account for this employee?
					</Card>
				</Modal.Body>
				<Modal.Footer>
					<button className="btn btn-secondary" onClick={() => setShowCreateUserModal(false)}>Cancel</button>
					<button className="btn btn-primary" onClick={() => createUser(data)}>Confirm</button>
				</Modal.Footer>
			</Modal>
		</div>
	);
};

export default ViewEmployee;
